import PollCheckDecoration from '@components/common/PollCheckDecoration'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded'
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded'
import HowToVoteRoundedIcon from '@mui/icons-material/HowToVoteRounded'

import { GlassCard } from '@components/common/Glass'
import { navy, displayFont } from 'src/ui/theme/tokens'
import Button from '@mui/material/Button'

export default function RandomList({
  fullScreen,
  onStartRandomList,
  onStartRandomPoll,
}: {
  fullScreen?: boolean
  onStartRandomList?: () => void
  onStartRandomPoll?: () => void
}): JSX.Element {
  return (
    <Box data-rt-tab-section sx={{ px: { xs: 1.5, sm: 3 }, pt: 1, pb: 4 }}>
      <GlassCard
        sx={{
          position: 'relative',
          background: navy,
          color: '#ffffff',
          textAlign: 'left',
          p: { xs: 3, sm: 4 },
          borderColor: '#335770',
          boxShadow: '0 4px 0 #bfd4e3, 0 12px 25px #183d5610',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: -25,
            top: -40,
            width: 240,
            height: 240,
            borderRadius: '50%',
            border: '34px solid #53d9f511',
            pointerEvents: 'none',
          }}
        />
        <Typography
          variant="overline"
          sx={{ color: '#a5d9ed', fontWeight: 700, letterSpacing: '.12em' }}
        >
          A fresh little brain adventure
        </Typography>
        <Box display="flex" alignItems="center" gap={{ xs: 2.5, sm: 3 }} mt={1} mb={2}>
          <Box
            sx={{
              flexShrink: 0,
              width: { xs: 70, sm: 92 },
              height: { xs: 80, sm: 100 },
              background: '#53d9f5',
              color: navy,
              borderRadius: '24px',
              display: 'grid',
              placeItems: 'center',
              transform: 'rotate(-8deg)',
              boxShadow: '0 5px 0 #319fbb',
            }}
          >
            <QuestionMarkRoundedIcon sx={{ fontSize: 60 }} />
          </Box>
          <Typography variant="h2" sx={{ fontSize: { xs: 31, sm: 44 }, color: 'inherit' }}>
            Surprise
            <br />
            your brain.
          </Typography>
        </Box>
        <Typography sx={{ color: '#c0d8e8', maxWidth: 400, mb: 3 }}>
          A mystery topic. Ten things to rank. What will you discover next?
        </Typography>
        <Button
          variant="contained"
          onClick={onStartRandomList}
          startIcon={<CasinoRoundedIcon />}
          sx={{
            width: { xs: '100%', sm: 'auto' },
            minHeight: 52,
            fontSize: 17,
          }}
        >
          Random Trivia
        </Button>
      </GlassCard>
      <GlassCard
        data-testid="random-poll-card"
        sx={{
          mt: 2.5,
          p: { xs: 2.5, sm: 3 },
          background: '#ffefdd',
          borderColor: '#efddc9',
          boxShadow: '0 3px 0 #efddc9',
          textAlign: 'left',
          position: 'relative',
          isolation: 'isolate',
          overflow: 'hidden',
          '& > :not(.rt-poll-decoration)': { position: 'relative', zIndex: 1 },
        }}
      >
        <PollCheckDecoration />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Box
            component="img"
            src="/brand/random-poll.svg"
            alt=""
            aria-hidden
            width={160}
            height={150}
            sx={{ width: { xs: 64, sm: 92 }, height: 'auto', flexShrink: 0 }}
          />
          <Typography
            variant="h2"
            sx={{
              fontFamily: displayFont,
              fontWeight: 600,
              fontSize: { xs: 28, sm: 36 },
              color: '#693413',
              minWidth: 0,
            }}
          >
            What&apos;s the community think?
          </Typography>
        </Box>
        <Typography variant="body2" color="#855c3d" sx={{ mb: 3 }}>
          Give your opinion. Discover the community&apos;s picks.
        </Typography>
        <Button
          color="secondary"
          variant="contained"
          onClick={onStartRandomPoll}
          startIcon={<HowToVoteRoundedIcon />}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          Random Poll
        </Button>
      </GlassCard>
    </Box>
  )
}
